import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer-layout1">
      <div className="space-extra-top">
        <div className="container">
          <div className="text-center">
            <div className="footer-logo">
              <Link to="/"><img src="/assets/img/logo.png" alt="Ninesister Jewels" /></Link>
            </div>
            <div className="footer-info">
              <a href="mailto:Ninesisters0819@gmail.com">Ninesisters0819@gmail.com</a>
              &nbsp;|&nbsp;
              <a href="tel:+918928218258">(+91) 89282 18258</a>
            </div>
            <div className="footer-menu">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/shop">Jewellery</Link>
              {/* <Link to="/shop-sidebar">Watch</Link> */}
              <Link to="/wishlist">Wishlist</Link>
              <Link to="/my-account">My Account</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center gy-2">
            <div className="col-md-6 text-center text-md-start">
              <p className="footer-copy mb-0">
                Copyright <i className="fal fa-copyright"></i> 2026{' '}
                <Link to="/">Ninesistersjewels.com</Link>. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="footer-legal">
                <Link to="/return-refund-policy">Return Policy</Link>
                <Link to="/shipping-policy">Shipping Policy</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
